/* eslint-disable no-param-reassign */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Grid, Modal, Step, StepLabel, Stepper } from '@mui/material';
import { isEmpty } from 'lodash';
import MapsAdvancedModalStepOne from '../MapsAdvancedModalStepOne';
import MapsAdvancedModalStepTwo from '../MapsAdvancedModalStepTwo';
import * as mapOps from '../../../api/Maps/map-operations';

const MapsAdvancedModal = props => {
  const { handleModalAdvancedMap, map, openModalAdvancedMap, userControlSetting } = props;
  const [activeStep, setActiveStep] = React.useState(0);
  const [disabledFinish, setDisabledFinish] = React.useState(false);
  const settingsAdvancedMapDefault = {
    buttonSettings: {
      showAjustarMapa: false,
      showChangeSize: true,
      showDownloadLayer: false,
      showModal: false,
      templateDefault: 'baseTemplate2',
      shareButtonByMobile: {
        name: 'Share',
        show: true
      }
    },
    catastroSettings: {
      streetTypeView: 'window',
      viewInformation: true
    },
    components: {
      AnnotationDirectButtons: { name: 'Botones directos', show: false },
      CatastroComponent: { name: 'Catastro de España', show: false },
      DownloadLinksComponent: { name: 'Descarga de links', show: false },
      FileToolsComponent: { name: 'Herramientas de achivos', show: false },
      InfoLayerSelection: { name: 'Información de layers', show: false },
      ISLComponent: { name: 'Ipsilum Server Less', show: false },
      IntroductionMapComponent: { name: 'Introducción', show: false },
      LayersControl: { name: 'Controlar layers', show: false },
      LocationComponent: { name: 'Locator', show: false },
      NotesComponent: { name: 'Notas', show: false },
      PointMapComponent: { name: 'Point on map', show: false },
      PythonComponent: { name: 'Python', show: false },
      SentinelComponent: { name: 'Sentinel', show: false },
      SharedComponent: { name: 'Compartir', show: false },
      // ShowMapDeckLidarComponent: { name: 'Mapa DeckGL', show: false }, // comment deck
      TableAnnotationsComponent: { name: 'Table Annotations', show: false },
      TableSourceComponent: { name: 'Table source', show: false },
      ViewLinksComponent: { name: 'Ver links', show: false }
    },
    downloadLinks: {
      connector: {},
      importFile: false,
      server: {},
      source: []
    },
    pointMap: {
      disc: 'data3/master_folder/htmls/lidar',
      importFile: false,
      server: {},
      source: [],
      streetViewType: 'inside'
    },
    defaultComponent: '',
    directButtons: {
      intervalTime: '5',
      projectId: '',
      savingSystem: 'incremental',
      templates: [],
      videoId: '',
      videoOptions: []
    },
    fileTools: { urlToUpload: '', serverConnection: {}, geojsonFunction: false },
    ipsOfIsl: { links: [], viewDefault: 'Listado' },
    locationSettings: {
      createRouteConfiguration: {
        avoidPointsMap: '',
        buttonCreateRoute: {
          name: 'Create route',
          show: false
        },
        centerOnRoute: false,
        show: false,
        endPoints: [],
        mode: 'foot-walking',
        endPointDefault: ''
      },
      buttonCurrentLocation: {
        name: 'Update my location',
        show: false
      },
      buttonToAddImage: {
        name: 'Upload image',
        show: false
      },
      buttonToAddIframe: {
        name: 'Upload iframe',
        show: false
      },
      buttonToAddVideo: {
        name: 'Upload video',
        show: false
      },
      typeComponent: 'Complex',
      trackingAnnotation: false,
      updatedAnnotation: false,
      updateAnnotationButton: 'Actualizar anotación',
      changeTemplate: false,
      templateConfiguration: {},
      createAnnotationButton: 'Crear anotación',
      defaultTemplate: '',
      description: 'Puedes seleccionar en el mapa tu ubicación.',
      goToCurrentLocation: false,
      image: '',
      intervalTime: '5',
      projectId: '',
      savingSystem: 'incremental',
      searchAddress: false,
      sendFirstLocation: false,
      showAddress: false,
      showAnnotation: false,
      showDescription: false,
      showImage: false,
      showName: false,
      showTracking: false,
      showTitle: false,
      showSharedButton: false,
      title: '',
      userNameTitle: false,
      videoId: '',
      zoom: 18
    },
    mapTypes: [{ name: 'Mapa', value: 'map' }],
    notes: {
      showAllNotes: false,
      showAllTracks: false,
      showAnnotations: false,
      showTrack: false,
      showNotes: false,
      showNotesDefault: false,
      centerNotes: false,
      centerNotesDefault: false,
      entWine: [],
      interval: { show: false, value: 10 },
      showGeomotion: false,
      showGeomotionPublic: false,
      showStreetView: false,
      showVideo: true,
      videos: [],
      showCreateAnnotation: true,
      showUpdateAnnotation: true,
      showDeleteAnnotation: true,
      showImportAnnotation: true,
      showExportAnnotation: true
    },
    orderOfComponents: [],
    pythonSettings: { layerIDs: [], showChangeLayer: false },
    tableAnnotations: { videoId: '', templateId: '', orderElement: 11, optionList: [] },
    shareOptions: {
      showPublicShare: true,
      showPrivateShare: true,
      showPublicUserShare: true,
      showPrivateUserShare: true,
      showShareByEmailMobile: true,
      buttonByEmailMobile: {
        name: 'Update my location',
        show: true
      }
    },
    showTooltip: false,
    sizeDrawer: { name: '33%', value: 100 / 3 },
    tableSource: { defaultSource: '', sources: [] },
    textSettings: {
      description: 18,
      descriptionHeight: 100,
      logoHeight: 100,
      font: 'Arial',
      logo: '',
      showImagen: true,
      showTitle: true,
      title: 24
    },
    viewLinks: []
  };

  const settingsAdvancedMapBBDD = mapOps.getSettingsAdvancedMap(map);

  const isEmptyObject = obj => {
    return Object.keys(obj).length === 0 && obj.constructor === Object;
  };

  const mergeSettingsWithDefault = (settingsBBDD, settingsDefault) => {
    if (!isEmptyObject(settingsBBDD)) {
      Object.keys(settingsDefault).forEach(key => {
        if (!(key in settingsBBDD)) {
          settingsBBDD[key] = settingsDefault[key];
        } else if (typeof settingsBBDD[key] === 'object' && !Array.isArray(settingsBBDD[key])) {
          Object.keys(settingsDefault[key]).forEach(subKey => {
            if (!(subKey in settingsBBDD[key])) {
              settingsBBDD[key][subKey] = settingsDefault[key][subKey];
            }
          });
        }
      });
    }
  };

  mergeSettingsWithDefault(settingsAdvancedMapBBDD, settingsAdvancedMapDefault);

  const settingsAdvancedMapInitial = isEmpty(settingsAdvancedMapBBDD)
    ? settingsAdvancedMapDefault
    : settingsAdvancedMapBBDD;

  if (userControlSetting.advancedComponents) {
    userControlSetting.advancedComponents.forEach(key => {
      if (!settingsAdvancedMapInitial.components[key]) {
        settingsAdvancedMapInitial.components[key] = { show: false };
      }
    });
  }
  const filteredComponents = Object.keys(settingsAdvancedMapInitial.components).filter(
    key => settingsAdvancedMapInitial.components[key].show === true
  );
  const orderInitial =
    settingsAdvancedMapInitial.orderOfComponents &&
    !isEmpty(settingsAdvancedMapInitial.orderOfComponents)
      ? settingsAdvancedMapInitial.orderOfComponents
      : filteredComponents;
  const [orderOfComponents, setOrderOfComponents] = React.useState(orderInitial);
  const [defaultComponent, setDefaultComponent] = React.useState(
    settingsAdvancedMapInitial.defaultComponent
  );
  const [listComponentsAdvanced, setListComponentsAdvanced] = React.useState(
    settingsAdvancedMapInitial.components
  );
  const [mapTypes, setMapTypes] = React.useState(settingsAdvancedMapInitial.mapTypes);
  const [notes, setNotes] = React.useState(settingsAdvancedMapInitial.notes);
  const steps = ['Components', 'Configuration'];
  const [sizeDrawer, setSizeDrawer] = React.useState(settingsAdvancedMapInitial.sizeDrawer);
  const [catastroSettings, setCatastroSettings] = React.useState(
    settingsAdvancedMapInitial.catastroSettings
  );
  const [textSettings, setTextSettings] = React.useState(settingsAdvancedMapInitial.textSettings);
  const [showTooltip, setShowTooltip] = React.useState(settingsAdvancedMapInitial.showTooltip);
  const [ipsOfIsl, setIpsOfIsl] = React.useState(settingsAdvancedMapInitial.ipsOfIsl || []);
  const [settingsAdvanced, setSettingsAdvanced] = React.useState(settingsAdvancedMapInitial);
  const isMobile = window.innerWidth < 500;

  const handleNext = () => {
    if (activeStep === steps.length - 1) {
      const settings = {
        buttonSettings: settingsAdvanced.buttonSettings,
        catastroSettings,
        components: listComponentsAdvanced,
        defaultComponent,
        directButtons: settingsAdvanced.directButtons,
        downloadLinks: settingsAdvanced.downloadLinks,
        fileTools: settingsAdvanced.fileTools,
        ipsOfIsl,
        locationSettings: settingsAdvanced.locationSettings,
        mapTypes,
        notes,
        orderOfComponents: settingsAdvanced.orderOfComponents,
        pointMap: settingsAdvanced.pointMap,
        pythonSettings: settingsAdvanced.pythonSettings,
        showTooltip,
        sizeDrawer,
        tableAnnotations: settingsAdvanced.tableAnnotations,
        tableSource: settingsAdvanced.tableSource,
        textSettings,
        shareOptions: settingsAdvanced.shareOptions,
        viewLinks: settingsAdvanced.viewLinks
      };
      handleModalAdvancedMap(settings);
      setActiveStep(0);
    } else {
      setActiveStep(prevActiveStep => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleDisabledFinish = value => {
    setDisabledFinish(value);
  };

  return (
    <>
      <Modal
        open={openModalAdvancedMap}
        style={{
          bgcolor: 'white',
          top: '2.5vh',
          left: '2.5vw'
        }}
      >
        <Box backgroundColor="white" width="95vw" height="95vh">
          <Box display="flex" height="10%" width="100%" alignItems="center" mr={5}>
            <Grid container direction="row" justifyContent="space-around" spacing={2}>
              <Grid item xs={1} sx={{ justifyContent: 'space-around', display: 'flex' }}>
                <Button
                  disabled={activeStep === 0}
                  sx={{
                    color: '#2A3F90'
                  }}
                  onClick={handleBack}
                >
                  Back
                </Button>
              </Grid>
              {isMobile !== true && (
                <Grid item xs={9}>
                  <Box sx={{ width: '90%' }}>
                    <Stepper activeStep={activeStep}>
                      {steps.map(label => {
                        const labelProps = {};
                        return (
                          <Step key={label}>
                            <StepLabel {...labelProps}>{label}</StepLabel>
                          </Step>
                        );
                      })}
                    </Stepper>
                  </Box>
                </Grid>
              )}
              <Grid item xs={2} sx={{ justifyContent: 'space-around', display: 'flex' }}>
                <Button
                  variant="contained"
                  sx={{
                    color: 'white',
                    backgroundColor: '#2A3F90'
                  }}
                  disabled={activeStep === steps.length - 1 ? disabledFinish : false}
                  onClick={handleNext}
                >
                  {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                </Button>
                <Button
                  color="success"
                  variant="outlined"
                  onClick={() => handleModalAdvancedMap(settingsAdvancedMapInitial)}
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Box>

          <Box height="85%" width="100%" ml={3} mr={3}>
            {activeStep === 0 && (
              <MapsAdvancedModalStepOne
                defaultComponent={defaultComponent}
                listComponentsAdvanced={listComponentsAdvanced}
                orderOfComponents={orderOfComponents}
                settingsAdvanced={settingsAdvanced}
                setDefaultComponent={setDefaultComponent}
                setListComponentsAdvanced={setListComponentsAdvanced}
                setOrderOfComponents={setOrderOfComponents}
                setSettingsAdvanced={setSettingsAdvanced}
                {...props}
              />
            )}
            {activeStep === steps.length - 1 && (
              <MapsAdvancedModalStepTwo
                catastroSettings={catastroSettings}
                defaultComponent={defaultComponent}
                handleDisabledFinish={handleDisabledFinish}
                ipsOfIsl={ipsOfIsl}
                listComponentsAdvanced={listComponentsAdvanced}
                mapTypes={mapTypes}
                notes={notes}
                setCatastroSettings={setCatastroSettings}
                setDefaultComponent={setDefaultComponent}
                setIpsOfIsl={setIpsOfIsl}
                setListComponentsAdvanced={setListComponentsAdvanced}
                setMapTypes={setMapTypes}
                setNotes={setNotes}
                setSettingsAdvanced={setSettingsAdvanced}
                setSizeDrawer={setSizeDrawer}
                setShowTooltip={setShowTooltip}
                setTextSettings={setTextSettings}
                settingsAdvanced={settingsAdvanced}
                showTooltip={showTooltip}
                sizeDrawer={sizeDrawer}
                textSettings={textSettings}
                {...props}
              />
            )}
          </Box>
        </Box>
      </Modal>
    </>
  );
};
export default MapsAdvancedModal;
MapsAdvancedModal.defaultProps = {
  openModalAdvancedMap: false
};
MapsAdvancedModal.propTypes = {
  handleModalAdvancedMap: PropTypes.func.isRequired,
  map: PropTypes.object.isRequired,
  openModalAdvancedMap: PropTypes.bool,
  userControlSetting: PropTypes.object.isRequired
};
